module.exports = __webpack_public_path__ + "static/media/dark_blue-s.7f21bc9b.svg";